import rut_1 from '../../../assets/images/rut1.png';
import rut_2 from '../../../assets/images/rut2.png';
import rut_3 from '../../../assets/images/rut3.png';
import rut_4 from '../../../assets/images/rut4.png';
import rut_5 from '../../../assets/images/rut5.png';

const slides = [
    {
        id: 1,
        image: rut_1,
    },
    {
        id: 2,
        image: rut_2,
    },
    {
        id: 3,
        image: rut_3,
    },
    {
        id: 4,
        image: rut_4,
    },
    {
        id: 5,
        image: rut_5,
    },
]

export default slides